/// <reference path="../../../../typings/index.d.ts" />
///<reference path="sections/main.section.ts"/>
///<reference path="../../components/baseClasses/dataMaintenanceContextBase.ts"/>

module Meevo.Plugins.YieldManagementStrategy {
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class YieldManagementStrategyContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public searchNoun: Meevo.Model.NounEnum;

        get availableLocationKey(): string {
            return this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEACCESS;
        }

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    $scope: angular.IScope,
                    private busyService: Meevo.Components.Busy.IBusyService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, true);

            this.baseEndpoint = appSettings.API_ENDPOINTS.yieldManagementStrategy;
            this.searchNoun = Meevo.Model.NounEnum.YieldManagementStrategySearchPage;
            this.sectionTemplatePath = 'app/plugins/yieldManagementStrategy/sectionViews/';
            this.entityType = 'yieldManagementStrategy';
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new YieldManagerStrategyMainSection(0,
                        'SECTION_WORKACTIVITIES_MAIN',
                        'main.html',
                        true,
                        false,
                        this.appSettings.API_ENDPOINTS.yieldManagementStrategy,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.YieldManagementStrategyMain,
                        this.modalService,
                        this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    )
                );
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        save(): angular.IPromise<any> {
            this.busyService.stop();
            if (this.mode === MaintenanceFormState.Editing && this.isModelActiveChanged() && !(<IYMStrategy>this.selectedSection.model).canBeInactivatedOrDeleted) {
                return this.modalService.yellowConfirm('MESSAGE_CONFIRM_INACTIVATE_STRATEGY')
                    .then(() => super.save());
            }

            return super.save();
        }

        showDeleteLogic(): boolean {
            return super.showDeleteLogic() && this.selectedSection.model.homeLocationId === this.identityService.current().locationId;
        }

        delete(): void {
            if (this.canDelete) {
                this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, {
                    showCancelButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON',
                    okButtonContentKey: 'LABEL_YES'
                }).then(() => {
                    if (!(<IYMStrategy>this.selectedSection.model).canBeInactivatedOrDeleted) {
                        this.modalService.alert('MESSAGE_CAN_NOT_BE_DELETED_STRATEGY');

                        return;
                    }

                    this.loadingInProgress = true;
                    this.dataService.objectStatePatch(this.baseEndpoint, this.itemId, this.selectedSection.model.entityVersion, <number>Model.ObjectStateEnum.Deleted, this.asLocationId, this.selectedSection.sectionEndpoint)
                        .then((data) => {
                            if (data) {
                                this.selectedSection.model = data;
                                this.selectedSection.sectionModelRetrieved();
                                this.loggingService.trace(`Delete saved.`);
                            }
                        })
                        .finally(() => {
                            this.loadingInProgress = false;
                        });
                });

            } else {
                this.modalService.alert('ERROR_HTTP_403');
            }

            this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
        }

        selectSection(item: Meevo.Components.BaseClasses.IDataMaintenanceSection<Meevo.Model.DataMaintenance>, subSectionContentKey?: string): void {
            this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY_TAB_MAIN, true, false);
            super.selectSection(item, subSectionContentKey);
        }

        get showCopy(): boolean {
            return false;
        }

        get canCopy(): boolean {
            return false;
        }

        private isModelActiveChanged(): boolean {
            return (<IYMStrategy>this.selectedSection.originalEntity).objectState === ObjectStateEnum.Active
                && (<IYMStrategy>this.selectedSection.model).objectState === ObjectStateEnum.Inactive;
        }
    }
}
